"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PasswordTokenModel", {
    enumerable: true,
    get: function() {
        return PasswordTokenModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const PasswordTokenModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    token: _zod.z.string(),
    user_id: _zod.z.instanceof(_bson.ObjectId)
});
